module.exports = __webpack_public_path__ + "e34b6fe0eb016984104fd594d6197a86.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/legui.png
// module id = 606
// module chunks = 0